import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  TabValue,
  makeStyles,
} from '@fluentui/react-components';
import { CheckmarkFilled, EditOffRegular, EditRegular } from '@fluentui/react-icons';

import { TPermissions, useCanEdit } from '@modules/access';

import { TLiterature, TLiteratureDraft, TLiteratureVersion } from '../types';

// No version dropdown in the header - it lives in the drawer overview (matches Document/File/InlineBlock).
const useStyles = makeStyles({
  menuButton: {
    '& .fui-MenuButton__menuIcon': {
      fontSize: '15px',
      marginBottom: '6px',
    },
  },
});

type TProps = {
  literature: TLiterature;
  version: TLiteratureVersion | TLiteratureDraft | undefined;
  selectedTab: TabValue;
  setSelectedTab: (value: TabValue) => void;
  permissions: TPermissions;
  handleEditDraft: () => void;
  handleComplete: () => void;
  isCreatingDraft: boolean;
};

const LiteratureHeader = ({
  literature,
  version,
  selectedTab,
  setSelectedTab,
  permissions,
  handleEditDraft,
  handleComplete,
  isCreatingDraft,
}: TProps) => {
  const classes = useStyles();

  const { canEdit } = useCanEdit(permissions.accessRight);

  const onTabSelect = (_: SelectTabEvent, data: SelectTabData) => setSelectedTab(data.value);

  return (
    <header className="sticky z-40 w-full">
      <div>
        <div className="flex pb-2 justify-between items-end">
          <TabList selectedValue={selectedTab} onTabSelect={onTabSelect} size="small">
            <Tab value="home">Home</Tab>
            <Tab value="assessments">Assessments</Tab>
            <Tab value="history">History</Tab>
          </TabList>

          <div className="flex space-x-2 items-center">
            <Menu>
              <MenuTrigger disableButtonEnhancement>
                <MenuButton size="small" icon={<EditOffRegular />} className={classes.menuButton}>
                  View mode
                </MenuButton>
              </MenuTrigger>
              <MenuPopover>
                {canEdit ? (
                  <MenuList>
                    <MenuItem icon={<EditRegular />} onClick={handleEditDraft} disabled={isCreatingDraft}>
                      {literature.draft ? 'Edit draft' : 'Create draft'}
                    </MenuItem>
                    {literature.draft && (
                      <MenuItem icon={<CheckmarkFilled />} onClick={handleComplete}>
                        Complete version
                      </MenuItem>
                    )}
                  </MenuList>
                ) : (
                  <p className="p-1">No actions available.</p>
                )}
              </MenuPopover>
            </Menu>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LiteratureHeader;
